import React from 'react';
import SizePickerActionButton from '../../index';
const ComingSoonButton = ({ labelMoveToCart, isIconVisible = true }) => {
    if (!labelMoveToCart) {
        return null;
    }
    return (React.createElement(SizePickerActionButton, { disabled: true, isIconVisible: isIconVisible }, labelMoveToCart));
};
export default ComingSoonButton;
//# sourceMappingURL=ComingSoonButton.js.map